import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import ProjectChoicesCard from './settings/ProjectChoicesCard';
import { useSettings } from '../contexts/SettingsContext';
import { useRole } from '../hooks/useRole';

/**
 * First-run prompt for a project that has not chosen its currency, timezone,
 * language and phone country yet. It stands in for the onboarding wizard, which
 * stays hidden until events return in a later wave. Shown to an owner only
 * (only an owner can save these), can be skipped, and goes away by itself once
 * everything is chosen.
 */
export default function ProjectSetupPrompt() {
  const { projectChoicesLoaded, projectChoices } = useSettings();
  const { isOwner } = useRole();
  const [skipped, setSkipped] = useState(false);

  const open = isOwner && projectChoicesLoaded && projectChoices.missing.length > 0 && !skipped;

  return (
    <Modal
      open={open}
      onClose={() => setSkipped(true)}
      title="Set up this project"
      size="medium"
      footer={
        <div className="modal-actions">
          <button type="button" className="btn-cancel" onClick={() => setSkipped(true)}>Skip for now</button>
        </div>
      }
    >
      <p className="modal-note">
        Choose the currency, timezone, language and phone country for this project. You can change them later in
        Settings, except the currency once money has been recorded.
      </p>
      <ProjectChoicesCard />
    </Modal>
  );
}
